import Modal from '@mui/material/Modal';
import React from 'react';
import Button from '../core/Button';
import styles from './CancelFormModal.module.scss';

export interface Props {
  open: boolean;
  separation: any;
  property: any;
  onClose: () => void;
  onSubmit: () => void;
}

export default function CancelFormModal(props: Props) {
  if (!props.open) {
    return null;
  }

  return (
    <Modal open className={styles.container} onClose={props.onClose}>
      <div className={styles.content}>
        <div>
          <h1>CANCELAR SEPARACIÓN</h1>
          <p>¿No llegaron a una negociación?</p>
        </div>
        <div>
          <small>El comprador será notificado</small>
        </div>
        <div className={styles.containerButtons}>
          <Button
            label="Aceptar"
            onClick={() => {
              props.onSubmit();
            }}
          />
          <Button label="Cerrar" onClick={props.onClose} />
        </div>
      </div>
    </Modal>
  );
}
